function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M10,0.5c-4.4,0-8,0.5-8,4v10c0,0.9,0.4,1.7,1,2.2v1.8c0,0.5,0.5,1,1,1h1c0.5,0,1-0.5,1-1v-1h8v1 c0,0.5,0.5,1,1,1h1c0.5,0,1-0.5,1-1v-1.8c0.6-0.5,1-1.3,1-2.2v-10C18,1,14.4,0.5,10,0.5z M10,2.5c3.7,0,5.1,0.5,5.7,1H4.3 C4.9,3,6.3,2.5,10,2.5z M16,14.5c0,0.4-0.2,0.6-0.3,0.7l-0.3,0.3H4.6l-0.3-0.3C4.2,15.1,4,14.9,4,14.5v-4h12V14.5z M16,8.5H4v-3h12 V8.5z M5,13c0-0.8,0.7-1.5,1.5-1.5S8,12.2,8,13s-0.7,1.5-1.5,1.5S5,13.8,5,13z M12,13c0-0.8,0.7-1.5,1.5-1.5S15,12.2,15,13 s-0.7,1.5-1.5,1.5S12,13.8,12,13z"
});

var SvgInTransit = function SvgInTransit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInTransit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/in_transit.8b8a888c.svg";
export { ForwardRef as ReactComponent };